<template>
    <v-dialog v-model="dialogOrderSettings" width="420">
        <v-card class="pa-3" outlined>
            <v-card-title class="pt-2 pl-1 pb-1 pl-7">
                <span class="text-h5">{{ $t('menu.orderSettings') }}</span>
                <v-spacer></v-spacer>
                <v-btn tag="a" icon @click="dialogOrderSettings = false">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-card-title>
            <p class="pl-7 my-0 font13 font-weight-regular">
                <v-icon small color="red" class="pb-1">mdi-information-outline</v-icon>
                {{ $t('menu.orderSettingsDisclaimer') }}
            </p>
            <AppForm v-if="toolUserSettingsDialog" ref="changeOrderSettingsForm" class="pl-4 pr-4">
                <v-card-text class="pa-0">
                    <AppDialogUserSettingsConfirm
                        ref="switchSite"
                        @deleteItem="switchSite"
                        @cancel="cancel"
                        :width="500"
                        :confirmButton="$t('menu.orderSettingsAccept')"
                        confirmButtoncolor="tbGreen"
                        :declineButton="$t('menu.orderSettingsDecline')"
                        declineButtonColor="red"
                    ></AppDialogUserSettingsConfirm>
                    <v-tabs color="grey darken-2" grow>
                        <v-tab class="font14">
                            {{ $t('menu.orderSettingsBookmaker') }}
                        </v-tab>
                        <v-tab class="font14">
                            {{ $t('menu.orderSettingsInput') }}
                        </v-tab>

                        <v-tab-item style="height: 445px">
                            <v-container class="tab-item-wrapper">
                                <v-row v-for="(site, index) in siteOrdered" :key="index">
                                    <v-col class="py-2 px-1 my-auto" cols="4">
                                        <v-switch
                                            v-model="toolUserSettingsDialog.bet_order_site_ids_allowed"
                                            :value="site.id"
                                            color="tbGreen"
                                            class="mb-2 mt-1"
                                            hide-details
                                            :ripple="false"
                                            false-value="false"
                                            @click.stop
                                            @change="showSwitchSiteForm(site.id)"
                                        >
                                            <template v-slot:label>
                                                <span :class="['bookmaker' + site.id, 'font14']">
                                                    {{ $const.SITE_NAME[site.id] }}
                                                </span>
                                            </template>
                                        </v-switch>
                                    </v-col>
                                    <v-col class="py-2 px-1 my-auto text-start" cols="4">
                                        <span class="font14">
                                            {{ $t('menu.orderSettingsMin') }}
                                            {{ utils.getCurrencySymbol(user.currency) }}{{ minStake(site.id) }}
                                        </span>
                                    </v-col>
                                    <v-col class="py-2 px-1 my-auto text-end">
                                        <span v-if="site.id in $const.SITE_RULES_LINK" class="font14 lightGreyText">
                                            <a target="_blank" :href="$const.SITE_RULES_LINK[site.id]">
                                                {{ $t('menu.orderSettingsRules') }}
                                            </a>
                                        </span>
                                    </v-col>
                                    <v-col class="py-2 px-1 my-auto text-end">
                                        <span v-if="site.id in $const.SITE_TERMS_LINK" class="font14 lightGreyText">
                                            <a target="_blank" :href="$const.SITE_TERMS_LINK[site.id]">
                                                {{ $t('menu.orderSettingsTC') }}
                                            </a>
                                        </span>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <p class="pt-1 pl-4 my-0 font13 font-weight-regular orangeText" style="text-align: justify">
                                        <!--                                    <v-icon small color="red" class="pb-1">mdi-information-outline</v-icon>-->
                                        {{ $t('menu.orderSettingsDisclaimerBottom') }}
                                    </p>
                                </v-row>
                            </v-container>
                        </v-tab-item>

                        <v-tab-item style="height: 445px">
                            <v-container class="tab-item-wrapper">
                                <v-row class="pt-2">
                                    <v-text-field
                                        outlined
                                        dense
                                        type="number"
                                        min="0"
                                        step="1"
                                        :prefix="utils.getCurrencySymbol(user.currency)"
                                        v-model="toolUserSettingsDialog.bet_order_stake_default"
                                        :label="$t('menu.orderSettingsStake')"
                                        :rules="rules.stake"
                                        color="grey"
                                        hide-details
                                        @input="
                                            toolUserSettingsDialog.bet_order_stake_default = $event !== '' ? $event : null;
                                            debouncedChangeSettings();
                                        "
                                        class="font14 bet"
                                    ></v-text-field>
                                </v-row>
                                <v-row class="pt-2">
                                    <v-select
                                        v-model="toolUserSettingsDialog.bet_order_odds_default_type_id"
                                        :label="$t('menu.orderSettingsOdds')"
                                        item-value="id"
                                        item-text="name"
                                        :items="getDefaultOddsTypeDictionary"
                                        outlined
                                        dense
                                        required
                                        hide-details
                                        @input="debouncedChangeSettings"
                                        class="font14 bet"
                                        color="grey"
                                    ></v-select>
                                </v-row>
                                <v-row class="pt-2">
                                    <v-switch
                                        v-model="toolUserSettingsDialog.bet_order_is_max_prices_default"
                                        :label="$t('menu.orderSettingsOddsButtons')"
                                        color="tbGreen"
                                        class="mt-0 pt-0 pl-1"
                                        hide-details
                                        :ripple="false"
                                        false-value="false"
                                        @change="debouncedChangeSettings"
                                    ></v-switch>
                                </v-row>
                                <v-row class="pt-2">
                                    <v-col class="pl-0 py-0 pr-1">
                                        <v-select
                                            v-model="toolUserSettingsDialog.bet_order_live_timeout_default"
                                            :label="$t('menu.orderSettingsTimeoutLive')"
                                            item-value="id"
                                            item-text="name"
                                            :items="getTimeoutLiveDictionary"
                                            outlined
                                            dense
                                            required
                                            hide-details
                                            @input="debouncedChangeSettings"
                                            class="font14 bet"
                                            color="grey"
                                        ></v-select>
                                    </v-col>
                                    <v-col class="pr-0 py-0 pl-1">
                                        <v-select
                                            v-model="toolUserSettingsDialog.bet_order_dball_timeout_default"
                                            :label="$t('menu.orderSettingsTimeoutDball')"
                                            item-value="id"
                                            item-text="name"
                                            :items="getTimeoutDballDictionary"
                                            outlined
                                            dense
                                            required
                                            hide-details
                                            @input="debouncedChangeSettings"
                                            class="font14 bet"
                                            color="grey"
                                        ></v-select>
                                    </v-col>
                                </v-row>
                                <v-row class="pt-2">
                                    <v-switch
                                        v-model="toolUserSettingsDialog.bet_order_is_suggested_prices_default"
                                        :label="$t('menu.orderSettingsStakeButtons')"
                                        color="tbGreen"
                                        class="mt-0 pt-0 pl-1"
                                        hide-details
                                        :ripple="false"
                                        false-value="false"
                                        @change="debouncedChangeSettings"
                                    ></v-switch>
                                </v-row>

                                <v-row class="pt-2">
                                    <v-combobox
                                        v-model="toolUserSettingsDialog.bet_order_suggested_prices_default"
                                        :label="$t('menu.orderSettingsStakes')"
                                        :disabled="!toolUserSettingsDialog.bet_order_is_suggested_prices_default"
                                        chips
                                        outlined
                                        dense
                                        hide-details
                                        clearable
                                        :rules="[rules.suggestedPrices(toolUserSettingsDialog)]"
                                        multiple
                                        class="suggested-prices"
                                        @input="debouncedChangeSettings"
                                    >
                                        <template v-slot:selection="{ attrs, item, select, selected }">
                                            <v-chip
                                                class="mb-1"
                                                style="padding: 0 8px; font-size: 13px"
                                                :color="$vuetify.theme.dark ? '#40414a' : '#d9ead3'"
                                                small
                                                v-bind="attrs"
                                                :input-value="selected"
                                                close
                                                :disabled="!toolUserSettingsDialog.bet_order_is_suggested_prices_default"
                                                @click="select"
                                                @click:close="removeSuggestedPrice(item)"
                                            >
                                                {{ utils.getCurrencySymbol(user.currency) }}{{ item }}
                                            </v-chip>
                                        </template>
                                    </v-combobox>
                                </v-row>
                                <v-row class="v-text-field__details pt-1">
                                    <div class="v-messages" :class="$vuetify.theme.dark ? 'whiteText' : 'blackText'" role="alert">
                                        <div class="v-messages__wrapper">
                                            <div class="v-messages__message">
                                                {{ $t('menu.orderSettingsStakesHint') }}
                                            </div>
                                        </div>
                                    </div>
                                </v-row>
                                <v-row class="pt-2">
                                    <v-checkbox
                                        v-model="toolUserSettingsDialog.bet_order_is_top_ups_default"
                                        :label="$t('menu.orderSettingsIsTopUps')"
                                        dense
                                        hide-details
                                        color="grey"
                                        :ripple="false"
                                        false-value="false"
                                        @change="debouncedChangeSettings"
                                    ></v-checkbox>
                                </v-row>
                                <v-row class="pt-2">
                                    <v-checkbox
                                        v-model="toolUserSettingsDialog.bet_order_is_request_bet_confirmation_default"
                                        :label="$t('menu.orderSettingsIsConfirmBet')"
                                        dense
                                        hide-details
                                        color="grey"
                                        :ripple="false"
                                        false-value="false"
                                        @change="debouncedChangeSettings"
                                    ></v-checkbox>
                                </v-row>
                                <v-row class="pt-2">
                                    <v-checkbox
                                        v-model="toolUserSettingsDialog.bet_order_is_keep_order_popup_open_default"
                                        :label="$t('menu.orderSettingsIsKeepOrderPopupOpen')"
                                        dense
                                        hide-details
                                        color="grey"
                                        :ripple="false"
                                        false-value="false"
                                        @change="debouncedChangeSettings"
                                    ></v-checkbox>
                                </v-row>
                                <v-row class="pt-2" style="height: 26px">
                                    <span class="font11 pl-1 d-flex flex-column align-center justify-center validation-error">
                                        {{ errorMessage }}
                                    </span>
                                </v-row>
                            </v-container>
                        </v-tab-item>
                    </v-tabs>
                    <!--                                </v-container>-->
                </v-card-text>
            </AppForm>
        </v-card>
    </v-dialog>
</template>
<style scoped>
    .tab-item-wrapper {
        min-height: 335px;
    }
</style>
<script>
    import AppDialogUserSettingsConfirm from 'Pages/core/confirm/AppDialogConfirm';
    import AppForm from 'Pages/core/form/AppForm';
    import { mapGetters } from 'vuex';
    import store from '~/store';
    import Vue from 'vue';
    import utils from 'Helpers/utils';

    export default {
        name: 'app-menuAccountChangeOrderSettingsDialog',
        components: {
            AppForm,
            AppDialogUserSettingsConfirm,
        },

        watch: {
            'toolUserSettingsDialog.bet_order_is_suggested_prices_default': function (newVal) {
                if (newVal && this.toolUserSettingsDialog.bet_order_suggested_prices_default === null) {
                    this.toolUserSettingsDialog.bet_order_suggested_prices_default = [...this.suggestedPrices[this.user.currency]];
                } else if (!newVal) {
                    this.toolUserSettingsDialog.bet_order_suggested_prices_default = null;
                }
            },
        },

        data() {
            return {
                dialogOrderSettings: false,
                loading: false,
                suggestedPrices: {
                    1: [5, 10, 15, 20, 50, 100], // EURO
                    4: [6, 10, 15, 20, 50, 100], // BRL
                },
                toolUserSettingsDialog: {},
                errorMessage: '',
                rules: {
                    stake: [
                        (v) => {
                            if (v) {
                                if (!utils.isNumeric(v)) {
                                    return store.$i18n.t('rules.integer');
                                } else if (v < 0) {
                                    return store.$i18n.t('rules.negative');
                                } else {
                                    let minStakes = store.getters['AppModule/getMinStakes'];
                                    let allowedSites = store.getters['AppModule/getToolUserSettings'].bet_order_site_ids_allowed;
                                    let minArr = [];

                                    minStakes = minStakes.bet_order.filter((minStake) => allowedSites.indexOf(minStake[0]) !== -1);

                                    minStakes.forEach(function (val) {
                                        minArr.push(val[1]);
                                    });

                                    let minValue = Math.min(...minArr);

                                    if (v < minValue) {
                                        return store.$i18n.t('rules.minStake', {
                                            currency: utils.getCurrencySymbol(store.getters['UserModule/getUser'].currency),
                                            value: minValue,
                                        });
                                    }
                                }
                            }

                            return true;
                        },
                    ],
                    // odds: [
                    //     (v) => {
                    //         if (parseFloat(v) <= 1) {
                    //             return store.$i18n.t('rules.min', { value: 1.1 });
                    //         } else if (parseFloat(v) > 100) {
                    //             return store.$i18n.t('betDialog.maxOdds', { value: 100 });
                    //         }
                    //         return true;
                    //     },
                    // ],
                    suggestedPrices(toolUserSettings) {
                        let v = toolUserSettings.bet_order_suggested_prices_default;
                        let result = true;

                        if (toolUserSettings.bet_order_is_suggested_prices_default) {
                            if (v && v.length === 0) {
                                return store.$i18n.t('rules.required');
                            }
                            if (v && v.length > 6) {
                                return store.$i18n.t('rules.max', { value: 6 });
                            }
                            if (v) {
                                v.forEach(function (item) {
                                    if (!utils.isNumeric(item)) {
                                        result = store.$i18n.t('menu.orderSettingsStakesMsg');
                                    }
                                });
                            }
                        }

                        return result;
                    },
                },
            };
        },

        created: function () {
            console.log('Component %s was created.', this.$options.name);

            this.debouncedChangeSettings = _.debounce(this.changeOrderSettings, 600);
        },

        mounted() {
            console.log('Component %s mounted.', this.$options.name);
        },

        methods: {
            open() {
                if (this.$refs.changeOrderSettingsDialog) {
                    this.$refs.changeOrderSettingsDialog.$refs.form.reset();
                    this.$refs.changeOrderSettingsDialog.$refs.form.resetValidation();
                }

                this.errorMessage = '';
                this.toolUserSettingsDialog = JSON.parse(JSON.stringify(this.toolUserSettings));

                this.dialogOrderSettings = true;
            },

            removeSuggestedPrice(item) {
                this.toolUserSettingsDialog.bet_order_suggested_prices_default.splice(
                    this.toolUserSettingsDialog.bet_order_suggested_prices_default.indexOf(item),
                    1
                );
                this.toolUserSettingsDialog.bet_order_suggested_prices_default = [...this.toolUserSettingsDialog.bet_order_suggested_prices_default];
                this.changeOrderSettings();
            },

            changeSettings() {
                let self = this;

                this.$store
                    .dispatch('UserModule/changeSettings', {
                        toolUserSettings: this.toolUserSettingsDialog,
                    })
                    .then((response) => {
                        if (response.data.success) {
                            self.toolUserSettings = JSON.parse(JSON.stringify(self.toolUserSettingsDialog));
                        }
                    });
            },
            changeOrderSettings() {
                this.$nextTick(() => {
                    if (this.$refs.changeOrderSettingsForm.$refs.form.validate()) {
                        this.errorMessage = '';
                        this.changeSettings();
                    } else {
                        for (const key in this.$refs.changeOrderSettingsForm.$refs.form.$el) {
                            if (this.$refs.changeOrderSettingsForm.$refs.form.inputs[key].errorBucket.length) {
                                this.errorMessage = this.$refs.changeOrderSettingsForm.$refs.form.inputs[key].errorBucket[0];
                                return;
                            }
                        }
                    }
                });
            },
            showSwitchSiteForm(siteId) {
                if (
                    this.toolUserSettingsDialog.bet_order_site_ids_allowed.indexOf(siteId) !==
                        -1 /*(siteId === this.$const.SITE_IBC_ID && utils.getPlatform() === this.$const.PLATFORM_TRADEBALL) ||*/ &&
                    siteId === this.$const.SITE_SING_ID
                ) {
                    this.$refs.switchSite.title = this.$const.SITE_NAME[siteId];
                    this.$refs.switchSite.item.id = siteId;
                    this.$refs.switchSite.confirmDefaultText = this.$t('menu.orderSettingsConfirmText', {
                        siteName: this.$const.SITE_NAME[siteId],
                    });
                    this.$refs.switchSite.open();
                } else {
                    this.changeOrderSettings();
                }
            },

            switchSite(params) {
                params.closeCallback();
                this.changeOrderSettings();
            },

            cancel(params) {
                let idx = this.toolUserSettingsDialog.bet_order_site_ids_allowed.indexOf(params.item.id);
                Vue.delete(this.toolUserSettingsDialog.bet_order_site_ids_allowed, idx);

                params.closeCallback();
            },

            minStake(siteId) {
                let minStakes = this.getMinStakes.bet_order;
                let result = minStakes.filter((minStake) => minStake[0] === siteId);

                return result[0] ? result[0][1] : null;
            },
        },

        computed: {
            ...mapGetters({
                getSiteDictionary: 'DictionariesModule/getSiteDictionary',
                getOrderSiteDictionary: 'DictionariesModule/getOrderSiteDictionary',
                getMinStakes: 'AppModule/getMinStakes',
                getDefaultOddsTypeDictionary: 'DictionariesModule/getDefaultOddsTypeDictionary',
                getTimeoutLiveDictionary: 'DictionariesModule/getTimeoutLiveDictionary',
                getTimeoutDballDictionary: 'DictionariesModule/getTimeoutDballDictionary',
            }),

            siteOrdered() {
                let order = [
                    this.$const.SITE_PINNA_ID,
                    this.$const.SITE_BETFAIR_ID,
                    this.$const.SITE_MATCHBOOK_ID,
                    this.$const.SITE_ISN_ID,
                    this.$const.SITE_3BET_ID,
                    this.$const.SITE_SHARPBET_ID,
                    this.$const.SITE_IBC_ID,
                ];
                return _.sortBy(this.getOrderSiteDictionary, function (obj) {
                    return _.indexOf(order, obj.site_id);
                });
            },

            toolUserSettings: {
                get() {
                    return this.$store.getters['AppModule/getToolUserSettings'];
                },
                set(value) {
                    this.$store.commit('AppModule/setToolUserSettings', value);
                },
            },

            user() {
                return this.$store.getters['UserModule/getUser'];
            },
        },
    };
</script>
